import { jsx } from 'react/jsx-runtime';
import { useCallback, useEffect, useMemo } from 'react';
import { styled, Menu, Divider } from '@mui/material';
import '../../../OverflowWindow/OverflowWindow.js';
import OverflowProvider from '../../../OverflowWindow/OverflowProvider.js';
import '../../../OverflowWindow/components/MenuCategory.js';
import '../../../OverflowWindow/components/ChecklistItems.js';
import MenuItem from '../../../OverflowWindow/components/MenuItem.js';
import '../../../OverflowWindow/components/SubMenuItem.js';
import 'tslib';
import '../../../OverflowWindow/components/CascadingProvider.js';

const StyledMenu = styled(Menu, {
    shouldForwardProp: prop => !['rtl'].includes(prop),
}) `
  ${({ rtl }) => rtl &&
    `
    direction: rtl;
    li {
      padding: 0 8px;
    }
  `};
`;
const RowContextMenu = ({ contextMenu, denseRowMenu = true, getRowMenu, onRowContextMenuOpen, onRowContextMenuClose, onClose, row, rtl, }) => {
    const onCloseInternal = useCallback(() => {
        onClose();
        if (row) {
            onRowContextMenuClose === null || onRowContextMenuClose === void 0 ? void 0 : onRowContextMenuClose(row);
        }
    }, [onClose, row, onRowContextMenuClose]);
    const onMenuItemClick = useCallback((children, onClick, e) => {
        e.stopPropagation();
        onClick(row, children, e);
        onCloseInternal();
    }, [onCloseInternal, row]);
    useEffect(() => {
        if (contextMenu !== null && row) {
            onRowContextMenuOpen === null || onRowContextMenuOpen === void 0 ? void 0 : onRowContextMenuOpen(row);
        }
    }, [contextMenu, onRowContextMenuOpen, row]);
    const menuItems = useMemo(() => {
        if (!getRowMenu || !row) {
            return [];
        }
        return getRowMenu(row) || [];
    }, [getRowMenu, row]);
    const hasItems = useMemo(() => {
        let itemsSum = 0;
        menuItems.map(({ items }) => (itemsSum += items.length));
        return itemsSum;
    }, [menuItems]);
    if (!hasItems) {
        return null;
    }
    if (!menuItems.length || !getRowMenu) {
        return null;
    }
    return (jsx(OverflowProvider, Object.assign({ dense: denseRowMenu }, { children: jsx(StyledMenu, Object.assign({ rtl: rtl, open: contextMenu !== null, onClose: onCloseInternal, disableAutoFocusItem: true, anchorReference: "anchorPosition", anchorPosition: contextMenu ? { top: contextMenu.mouseY - 2, left: contextMenu.mouseX - 4 } : undefined, transformOrigin: {
                vertical: 'top',
                horizontal: rtl ? 'right' : 'left',
            } }, { children: menuItems.map(({ items }, index) => {
                return [
                    ...items.map(({ children, onClick, disabled, hint }, index) => (jsx(MenuItem, Object.assign({ onClick: e => onMenuItemClick(children, onClick, e), "data-testid": `menuItem-${index}`, disabled: disabled, hint: hint }, { children: children }), `menuItem-${index}`))),
                    ...(index + 1 < menuItems.length ? [jsx(Divider, {}, `${index}-divider`)] : []),
                ];
            }) })) })));
};

export { RowContextMenu as default };
//# sourceMappingURL=RowContextMenu.js.map
